import Table from '@components/table'
import { Fragment } from 'react/jsx-runtime'
import { eye, outlineuser, totalusers } from '../../../assets/icons'
import { columns } from './column'
import { Edit, Eye } from 'lucide-react'
import Title from '@components/title'
import Column from '@components/column'
import { useSelector } from 'react-redux'
import { RootState } from '@store/index'
import { Cards, Match } from '@apis/index'
import { useEffect, useState } from 'react'
import DashboardCard from '@commons/cards/dashboard'

const cardConfig = [
  {
    key: 'totalUsers',
    title: 'Total Users',
    icon: totalusers,
    isUp: true,
    link: '/admin/user-management',
  },
  {
    key: 'totalMatches',
    title: 'Total Matchrooms',
    icon: totalusers,
    isUp: true,
    link: '/admin/game-management/match-rooms',
  },
  {
    key: 'totalMatchesOnGoing',
    title: 'Active Matchrooms',
    icon: totalusers,
    isUp: false,
    link: '/admin/game-management/match-results?tab=Awaiting Results',
  },
  {
    key: 'totalMatchesCreatedByAdmin',
    title: 'Admin Created Matchroom',
    icon: totalusers,
    isUp: false,
    link: '/admin/game-management/match-results?tab=Admin Created',
  },
  {
    key: 'totalMatchesCreatedByUser',
    title: 'Player Created Matchroom',
    icon: totalusers,
    isUp: false,
    link: '/admin/game-management/match-results?tab=Player Created',
  },
  {
    key: 'totalOrdersPending',
    title: 'Pending Store Orders',
    icon: totalusers,
    isUp: false,
    link: '/admin/store-management/order',
  },
  {
    key: 'totalOrders',
    title: 'Total Store Orders',
    icon: totalusers,
    isUp: true,
    link: '/admin/store-management/order',
  },
  {
    key: 'totalSolvedTickets',
    title: 'Solved Tickets',
    icon: totalusers,
    isUp: true,
    link: '/admin/support-tickets?tab=Solved Tickets',
  },
  {
    key: 'totalUnsolvedTickets',
    title: 'Pending Tickets',
    icon: totalusers,
    isUp: false,
    link: '/admin/support-tickets?tab=Pending Tickets',
  },
  {
    key: 'totalPendingWithdraw',
    title: 'Pending Withdrawals',
    icon: totalusers,
    isUp: false,
    link: '/admin/payment/withdraw',
  },
]

const Dashboard = () => {
  const [search, setSearch] = useState('')
  const {
    items: matches,
    totalItems,
    totalPages,
  } = useSelector((state: RootState) => state.matches)
  const [page, setPage] = useState(1)
  const fetchMatches = async (search = '') => {
    try {
      await Match.list({
        state: 'matches',
        params: { page, limit: 30, status: 'On Going', search },
      })
    } catch (error) {}
  }
  const data = matches.map((m) => ({
    matchId: m.id,
    user: m.user,
    createdBy: {
      name: m.createdBy,
      user: m.user,
    },
    matchRoomName: m?.name,
    gameName: m.type,
    matchType: m.infos.gameSettings.matchType,
    matchTime: {
      date: m.date,
    },
    status: m.status,
  }))
  useEffect(() => {
    setPage(1)
  }, [])
  useEffect(() => {
    fetchMatches(search)
  }, [search, page])

  return (
    <Fragment>
      <Column>
        <DashboardCard cardConfig={cardConfig} />
        <Table
          onSearchChange={(val) => {
            setSearch(val)
          }}
          text="Active Matchrooms"
          icon={outlineuser}
          data={data}
          columns={columns}
          searchKeys={['name']}
          totalItems={totalItems}
          totalPages={totalPages}
          pageControlled={page}
          onPageChange={setPage}
          itemsPerPage={30}
        />
      </Column>
    </Fragment>
  )
}
export default Dashboard
